import React, { useCallback } from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import s from './dropdown.module.css';
import { handleKeyPressEnter } from '../../utils/handle-keypress-enter';
var SimpleControl = function SimpleControl(_ref) {
  var children = _ref.children,
    opened = _ref.opened,
    refControl = _ref.refControl,
    size = _ref.size,
    dataTest = _ref.dataTest,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? false : _ref$arrow,
    onToggle = _ref.onToggle;
  var handleToggle = useCallback(function (event) {
    if (disabled) {
      return;
    }
    if (onToggle) {
      onToggle(!opened, event);
    }
  }, [opened, onToggle, disabled]);
  return React.createElement("div", {
    ref: refControl,
    onClick: handleToggle,
    onKeyPress: handleKeyPressEnter(handleToggle),
    role: "button",
    tabIndex: 0,
    className: classNames(s.control, size && s[size], block && s.block, disabled && s.disabled),
    "data-test": dataTest
  }, children, arrow && React.createElement("div", {
    className: classNames(s.arrow, opened && s.opened)
  }, React.createElement(Icon, {
    name: "chevron-down",
    size: "s"
  })));
};
export default SimpleControl;